:host {
  @apply block;
}

::slotted(vds-thumbnail-list-item) {
  @apply py-[10px];
}

::slotted(:first-child) {
  @apply pt-0;
}

::slotted(:last-child) {
  @apply pb-0;
}
